/**
 * Nexus-Plugins Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-plugin-config.md
 */

const PLUGINS = [
  {
    identifier: 'registrar-inwx',
    kind: 'domain',
    enabled: true,
    is_default: true,
    loaded: true,
    config: { default_nameservers: ['ns1.valitype.com', 'ns2.valitype.com'] },
    updated_at: '2026-06-12T08:00:00Z',
  },
  {
    identifier: 'hosting-enhance',
    kind: 'hosting',
    enabled: true,
    is_default: true,
    loaded: true,
    config: { default_plan_id: 17 },
    updated_at: '2026-06-12T08:00:00Z',
  },
  {
    identifier: 'games-pterodactyl',
    kind: 'game',
    enabled: false,
    is_default: false,
    loaded: false,
    config: {},
    updated_at: '2026-06-10T08:00:00Z',
  },
  {
    identifier: 'vps-proxmox',
    kind: 'vps',
    enabled: true,
    is_default: true,
    loaded: true,
    config: { node_pool: 'pve01,pve02' },
    updated_at: '2026-06-12T08:00:00Z',
  },
  {
    identifier: 'cloud-argocd',
    kind: 'cloud',
    enabled: true,
    is_default: true,
    loaded: true,
    config: { sync_window_seconds: 60 },
    updated_at: '2026-06-12T08:00:00Z',
  },
];

export function nexusPluginsFixture() {
  return { plugins: PLUGINS };
}

export function probeFixture(id) {
  const plugin = PLUGINS.find((p) => p.identifier === id);
  if (!plugin) {
    return { ok: false, latency_ms: 0, detail: 'plugin not found' };
  }
  if (!plugin.enabled) {
    return { ok: false, latency_ms: 0, detail: 'plugin disabled' };
  }
  return {
    ok: true,
    latency_ms: Math.floor(80 + Math.random() * 200),
    detail: `OK — ${plugin.identifier} responded`,
  };
}

// Plugin-Schema-Konfiguration für den Credential-Editor.
// Pro Plugin: welche Felder sind nötig, welche sind secret (= AEAD-verschlüsselt).
// Quelle: Spec § "Plugin-spezifische Felder" + src/plugins/* in Nexus.
export const PLUGIN_CRED_SCHEMA = {
  'registrar-inwx': [
    { key: 'endpoint', label: 'Endpoint', secret: false, placeholder: 'https://api.domrobot.com/jsonrpc/' },
    { key: 'username', label: 'Username', secret: false },
    { key: 'password', label: 'Passwort', secret: true },
  ],
  'hosting-enhance': [
    { key: 'base_url', label: 'Base-URL', secret: false, placeholder: 'https://control.enhance.com' },
    { key: 'api_token', label: 'API-Token', secret: true },
  ],
  'games-pterodactyl': [
    { key: 'base_url', label: 'Panel-URL', secret: false, placeholder: 'https://panel.example.com' },
    { key: 'api_token', label: 'Application-Key', secret: true },
  ],
  'vps-proxmox': [
    { key: 'base_url', label: 'PVE-Cluster-URL', secret: false, placeholder: 'https://pve.example.com:8006' },
    { key: 'token_id', label: 'Token-ID', secret: false, placeholder: 'orbit@pve!operator' },
    { key: 'token_secret', label: 'Token-Secret', secret: true },
  ],
  'cloud-argocd': [
    { key: 'base_url', label: 'ArgoCD-URL', secret: false, placeholder: 'https://argocd.example.com' },
    { key: 'api_token', label: 'API-Token', secret: true },
  ],
  // #282 deSEC-DNS (Token-Auth). INWX-DNS nutzt die registrar-inwx-Credentials.
  'dns-desec': [
    { key: 'token', label: 'deSEC API-Token', secret: true },
  ],
  // #289 Bunny.net DNS (inkl. GEO-DNS) — AccessKey aus dem Bunny-Dashboard.
  'dns-bunny': [
    { key: 'access_key', label: 'Bunny DNS AccessKey', secret: true },
  ],
  // #287 SSL-Provider Actalis (ACME/EAB). kid ist nicht geheim, HMAC schon.
  'ssl-actalis': [
    { key: 'eab_kid', label: 'EAB Key-ID (kid)', secret: false },
    { key: 'eab_hmac', label: 'EAB HMAC-Key', secret: true },
    { key: 'contact_email', label: 'ACME-Kontakt-E-Mail', secret: false, placeholder: 'ssl@valitype.com' },
    { key: 'directory_url', label: 'ACME-Directory-URL', secret: false, placeholder: 'https://acme-api.actalis.com/acme/directory' },
  ],
  // #287 SSL-Provider ZeroSSL (ACME/EAB) — dieselben Felder wie Actalis.
  'ssl-zerossl': [
    { key: 'eab_kid', label: 'EAB Key-ID (kid)', secret: false },
    { key: 'eab_hmac', label: 'EAB HMAC-Key', secret: true },
    { key: 'contact_email', label: 'ACME-Kontakt-E-Mail', secret: false, placeholder: 'ssl@valitype.com' },
    { key: 'directory_url', label: 'ACME-Directory-URL', secret: false, placeholder: 'https://acme.zerossl.com/v2/DV90' },
  ],
};
